import { __module as selector } from "../../../../../../../_virtual/selector.js";
import { __require as requireContainer } from "./container.js";
import { __require as requireTypes } from "./types.js";
var hasRequiredSelector;
function requireSelector() {
  if (hasRequiredSelector) return selector.exports;
  hasRequiredSelector = 1;
  (function(module, exports$1) {
    exports$1.__esModule = true;
    exports$1["default"] = void 0;
    var _container = _interopRequireDefault(requireContainer());
    var _types = requireTypes();
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function _inheritsLoose(subClass, superClass) {
      subClass.prototype = Object.create(superClass.prototype);
      subClass.prototype.constructor = subClass;
      _setPrototypeOf(subClass, superClass);
    }
    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
        o2.__proto__ = p2;
        return o2;
      };
      return _setPrototypeOf(o, p);
    }
    var Selector = /* @__PURE__ */ (function(_Container) {
      _inheritsLoose(Selector2, _Container);
      function Selector2(opts) {
        var _this;
        _this = _Container.call(this, opts) || this;
        _this.type = _types.SELECTOR;
        return _this;
      }
      return Selector2;
    })(_container["default"]);
    exports$1["default"] = Selector;
    module.exports = exports$1.default;
  })(selector, selector.exports);
  return selector.exports;
}
export {
  requireSelector as __require
};
//# sourceMappingURL=selector.js.map
